import { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { MemberNotes } from '@src/routes/members/notes'
import Checkup from '@src/data/checkup'
import { API } from '@src/lib/api_path'
import { snakecaseKeys } from '@src/util/functions'
import ApiClient from '@src/lib/api_client'
import { WizardNoteList } from '@src/routes/members/components/wizard/components/notes/list'
import { WizardCreateNote } from '@src/routes/members/components/wizard/components/notes/create'
import Note from '@src/data/note'

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    },
    filteredNoteIds () {
      return this.$store.state.filteredNotes.map(note => note.id)
    }
  }
})
export class WizardMemberNotes extends MemberNotes {

  @Prop({ required: false, default: false })
  private isReadonly: boolean

  private checkup: Checkup

  private apiClient: ApiClient

  private filteredNoteIds: number[]

  constructor () {
    super()

    this.apiClient = new ApiClient()
  }

  created () {
    this.$store.dispatch('setNote', new Note({ createdAt: new Date(), tags: [], text: '' }))
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.CHECKUPS')}`
  }

  beforeDestroy () {
    if (!this.isReadonly) {
      return this.updateCheckup()
    }
  }

  render (h: CreateElement) {

    return <div class='member-notes-wrapper'>
      <div class='content'>
        {!this.isReadonly ? <WizardCreateNote /> : null}
        <WizardNoteList checkup={this.checkup} isReadonly={this.isReadonly} />
      </div>
    </div>
  }

  private async updateCheckup () {
    let checkup = new Checkup(this.checkup)
    checkup.noteIds = this.filteredNoteIds
    checkup.notesAdded = true
    checkup.updateState()
    this.$store.dispatch('setCheckup', checkup)

    await this.apiClient.put(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.$route.params.id)}/${checkup.id}`, { checkup: snakecaseKeys(checkup) })
      .catch(err => console.error('Failed to update checkup, ', err))
  }
}
